import React from 'react'
import StatusPill from '@Components/StatusPills/StatusPill'
import { WorkMergeRequestStatus } from '@Entities/rightsholder/work-merge'

export const workMergeStatusText: Record<WorkMergeRequestStatus, string> = {
    PENDING: 'Pending',
    ACCEPTED: 'Accepted',
    PARTIALLY_ACCEPTED: 'Partially Accepted',
    REJECTED: 'Rejected',
    COMPLETED: 'Completed',
}

const submissionStatusText: Record<WorkMergeRequestStatus, string> = {
    ...workMergeStatusText,
    PENDING: 'Submitted',
}

interface WorkMergeStatusPillProps {
    status: WorkMergeRequestStatus
}

const WorkMergeStatusPill = ({ status }: WorkMergeStatusPillProps) => (
    <StatusPill text={submissionStatusText[status]} color="gray" />
)

export default WorkMergeStatusPill
